import type { ReactNode } from "react";
import { cn } from "@/utils/cn";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-12",
        className
      )}
    >
      <span className="flex items-center justify-center w-14 h-14 rounded-full bg-background-100 text-primary-600 mb-4">
        <i className={cn(icon, "text-2xl")} aria-hidden="true" />
      </span>
      <h3 className="text-base font-heading font-semibold text-foreground-950">{title}</h3>
      {description && <p className="mt-1.5 max-w-sm text-sm text-foreground-600">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}